import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useRegionScope } from "../../../contexts/RegionScopeContext.js";
import { SelectRecordRenderComponents } from "./SelectRecord.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
//#region src/modules/Records/shared/SearchFilterRecordMultiSelect.tsx
var LIMIT = 25;
function SearchFilterRecordMultiSelect({ focused, label = "Records", onChange, onClearSelection, onClick, value }) {
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const { rpcService } = useRPCContext();
	const regionScope = useRegionScope();
	useEffect(() => {
		setLoading(true);
		rpcService.Records.GetRecordsList.v1.call({
			pagination: { limit: LIMIT },
			regionIds: regionScope
		}).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.records);
		}).finally(() => setLoading(false));
	}, [regionScope]);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Records.GetRecordsList.v1.call({
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.records]);
		});
		else if (opts.text) rpcService.Records.GetRecordsList.v1.call({
			pagination: { limit: LIMIT },
			regionIds: regionScope,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.records);
		});
	};
	return /* @__PURE__ */ jsx("div", {
		className: "bg-surface-strong p-xs",
		children: /* @__PURE__ */ jsxs("div", {
			className: "space-y-sm w-full font-bold",
			onClick,
			children: [/* @__PURE__ */ jsxs("span", {
				className: "flex w-full justify-between hover:cursor-pointer",
				children: [/* @__PURE__ */ jsx("span", { children: label }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
			}), focused && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				children: /* @__PURE__ */ jsx(MultiSelect, {
					disabled: loading,
					disableSelectAll: true,
					loading,
					onChangeValue: onChange,
					onClearSelection,
					loadOptions: handleLoadOptions,
					optionLabelExtractor: (option) => option.title,
					options,
					optionValueExtractor: (option) => option.id || "",
					placeholder: "Record",
					renderOption: SelectRecordRenderComponents.ListItem,
					totalOptions,
					value: value || []
				})
			})]
		})
	});
}
//#endregion
export { SearchFilterRecordMultiSelect };

//# sourceMappingURL=SearchFilterRecordMultiSelect.js.map